<template>
  <div>
    <div class="eject_content" style="width:100%">
      <div style="text-align:center;display: flex;justify-content: space-between;">
        <a-radio-group
          v-model="changeValue" default-value="img" button-style="solid" @change="handleChange"
        >
          <a-radio-button value="video" style="display:none">
            视频
          </a-radio-button>
        </a-radio-group>
        <!-- <a-form-item
          v-show="changeValue === 'img'" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
          label="选择日期:"
        >
          <a-range-picker
            v-model="times" value-format="YYYY-MM-DD"
            @change="onTime"
          />
        </a-form-item> -->
      </div>
      <div>
        <!-- <a-spin :spinning="spinImg" tip="加载中...">
          <div v-show="changeValue === 'img'" class="pic">
            <div v-if="imgdata && imgdata.length !== 0">
              <div v-for="(item,index) in imgdata" :key="index">
                <div class="pic_top">
                  <div>
                    <span></span><span>{{ item.date }}</span>
                  </div>
                  <div v-if="item.photoList.length > 6" style="color: #1890ff;cursor: pointer" @click="toggle(item)">
                    <a-icon v-show="item.show" type="up" />
                    <a-icon v-show="!item.show" type="down" />
                    {{ item.show ? '收起': '展开' }}
                  </div>
                </div>
                <div class="pic_bot">
                  <a
                    v-for="(imglt,id) in item.photoList" v-if="id < 6"
                    :key="id" href="javascript:;" class="img_list"
                    @click="viewImg(imglt.id,imglt.createTime)"
                  >
                    <div>
                      <span style="position: absolute;top: 77px;left: 7px;color: #ffffff;">{{ imglt.createTime.substring(11,19) }}</span>
                      <span style="position:absolute;top:77px;right:7px"><img
                        style="width:100%;height:100%;" src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210707/162563854804933bd1d5f443b4dfc854900b623e37450.png" alt=""
                        srcset=""
                      ></span>
                      <span style="position: absolute;top: 0;left: 0;">
                        <span v-if="imglt.qualified === 0" style="color: #fff;">
                          <div class="qualified"></div>
                          <div class="spanText">合格</div>
                        </span>
                        <span v-else-if="imglt.qualified === 1" style="color: #fff;">
                          <div class="noqualified"></div>
                          <div class="spanText">不合格</div>
                        </span>
                        <span v-else></span>
                      </span>
                      <img
                        :src="imglt.image + '?x-oss-process=image/resize,m_fill,w_150,h_150/quality,q_30'"
                        @click="showModal"
                      >
                    </div>
                  </a>
                  <a
                    v-for="(imglt,id) in item.photoList" v-show="item.show" v-if="id >= 6" :key="id"
                    href="javascript:;" class="img_list"
                    @click="viewImg(imglt.id,imglt.createTime)"
                  >
                    <div>
                      <span style="position: absolute;top: 77px;left: 7px;color: #ffffff;">{{ imglt.createTime.substring(11,19) }}</span>
                      <span style="position:absolute;top:77px;right:7px"><img
                        style="width:100%;height:100%;" src="http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210707/162563854804933bd1d5f443b4dfc854900b623e37450.png" alt=""
                        srcset=""
                      ></span>
                      <span style="position: absolute;top: 0;left: 0;">
                        <span v-if="imglt.qualified === 0" style="color: #fff;">
                          <div class="qualified"></div>
                          <div class="spanText">合格</div>
                        </span>
                        <span v-else-if="imglt.qualified === 1" style="color: #fff;">
                          <div class="noqualified"></div>
                          <div class="spanText">不合格</div>
                        </span>
                        <span v-else></span>
                      </span>
                      <img
                        :src="imglt.image + '?x-oss-process=image/resize,m_fill,w_150,h_150/quality,q_30'"
                        @click="showModal"
                      >
                    </div>
                  </a>
                </div>
                <a-divider />
              </div>
            </div>
            <div v-else>
              <a-empty />
            </div>
          </div>
        </a-spin> -->
        <div v-show="changeValue === 'video'" class="video" style="text-align: center;margin: 20px 0;">
          <div v-if="videoArr && videoArr.length !== 0">
            <template v-for="(item,index) in videoArr">
              <iframe
                v-if="item.src"
                :key="index"
                class="ysOpenDevice"
                :src="item.src"
                width="80%"
                height="500"
                allowfullscreen
              >
              </iframe>
              <div v-else :key="index" class="ysOpenDevice">
                {{ item.name + '(' + item.msg + ')' }}
              </div>
            </template>
          </div>
          <div v-else>
            <a-empty />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDeviceVideo } from '@/api/system'
export default {
  data () {
    return {
      changeValue: 'video',
      videoArr: []
    }
  },
  mounted () {
    const id = this.$route.query.id
    this.getDeviceVideo(id)
  },
  methods: {
    handleChange () {

    },
    getDeviceVideo ({ id }) {
      const params = {
        id: id
      }
      this.$httpPost(this.$basePath.getEzopenByProductId, {
        id: this.$route.query.id
      }).then(res => {
        // const arr = res.result
        // this.videoArr = []
        // arr.forEach(item => {
        //   if (item.state === 0) {
        //     this.videoArr.push({
        //       src: `https://open.ys7.com/ezopen/h5/iframe?url=${item.url}&autoplay=1&accessToken=${item.token}`
        //     })
        //   } else {
        //     this.videoArr.push({
        //       msg: item.msg,
        //       name: item.name
        //     })
        //   }
        // })
        if (!res.result.length) return
        this.videoArr = []
        res.result.forEach(item => {
          if (item.state === 0) {
            this.videoArr.push({
              src: `https://open.ys7.com/ezopen/h5/iframe?url=${item.url}&autoplay=1&accessToken=${item.token}`
            })
          } else {
            this.videoArr.push({
              msg: item.msg,
              name: item.name
            })
          }
        })
      })
    }
  }
}
</script>

<style>

</style>
